const STORAGE_KEY_PREFIX = "cineblocks:person"

export function saveFilePreview(personId: number, field: string, url: string): void {
  const key = `${STORAGE_KEY_PREFIX}:${personId}:files`
  const previews = JSON.parse(localStorage.getItem(key) || "{}")
  previews[field] = url
  localStorage.setItem(key, JSON.stringify(previews))
}

export function getFilePreview(personId: number, field: string): string | null {
  const key = `${STORAGE_KEY_PREFIX}:${personId}:files`
  const previews = JSON.parse(localStorage.getItem(key) || "{}")
  return previews[field] || null
}

export function clearFilePreviews(personId: number): void {
  const key = `${STORAGE_KEY_PREFIX}:${personId}:files`
  localStorage.removeItem(key)
}

export function clearCompletedSteps(personId: number): void {
  const key = `${STORAGE_KEY_PREFIX}:${personId}:steps`
  localStorage.removeItem(key)
}
